const _ = require("lodash");
const PREPAID_TRANSACTIONS_COLLECTION = "prepaid_transactions";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data()
  };
};

function PrepaidTransactionsMixin() {
  return {
    async createPrepaidTransaction(data) {
      const ref = await this.collection(PREPAID_TRANSACTIONS_COLLECTION).add(data);
      return {
        id: ref.id,
        ...data
      };
    },

    async fetchPrepaidTransactionsWithOrganizationId(organizationId, sorted = false) {
      const prepaidTransactions1 = await this.collection(PREPAID_TRANSACTIONS_COLLECTION)
        .where("organizationId", "==", organizationId)
        .get()
        .then(populateSnapshots);
      const prepaidTransactions2 = await this.collection(PREPAID_TRANSACTIONS_COLLECTION)
        .where("fromOrganizationId", "==", organizationId)
        .get()
        .then(populateSnapshots);
      const prepaidTransactions3 = await this.collection(PREPAID_TRANSACTIONS_COLLECTION)
        .where("toOrganizationId", "==", organizationId)
        .get()
        .then(populateSnapshots);

      const prepaidTransactions = [
        ...prepaidTransactions1,
        ...prepaidTransactions2,
        ...prepaidTransactions3
      ];

      if (!sorted) {
        return prepaidTransactions;
      }

      const sortedPrepaidTransactions = _.orderBy(prepaidTransactions, "date", "desc");

      return sortedPrepaidTransactions;
    },

    async fetchPrepaidTransactionsWithCampaignId(campaignId) {
      const prepaidTransactions = await this.collection(PREPAID_TRANSACTIONS_COLLECTION)
        .where("campaignId", "==", campaignId)
        .get()
        .then(populateSnapshots);

      return prepaidTransactions;
    },

    async getPrepaidTransactionById(id) {
      return await this.collection(PREPAID_TRANSACTIONS_COLLECTION)
        .doc(id)
        .get()
        .then(extractSnapshotData);
    },

    async updatePrepaidTransactionById(id, data) {
      return await this.collection(PREPAID_TRANSACTIONS_COLLECTION)
        .doc(id)
        .set(data, { merge: true });
    },

    async getPrepaidTransactionsByOrgaId(orgaId) {
      const prepaidTransactions = await this.collection(PREPAID_TRANSACTIONS_COLLECTION)
        .where("organizationId", "==", orgaId)
        .where("type", "==", "topUp")
        .get()
        .then(populateSnapshots);

      return prepaidTransactions;
    },

    async deletePrepaidTransactionById(id) {
      return await this.collection(PREPAID_TRANSACTIONS_COLLECTION).doc(id).delete();
    },

    async getTopUpPrepaidTransactions() {
      const organizations = await this.collection(PREPAID_TRANSACTIONS_COLLECTION)
        .where("type", "==", "topUp")
        .get()
        .then(populateSnapshots);

      return organizations;
    }
  };
}

module.exports = PrepaidTransactionsMixin;
